import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { BaseBackResponse, FileId } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}salesforce/context`;

export interface CreateContextIfNotExistCommandPayload {
  fileId: FileId;
}

async function createContextIfNotExistCommand({
  fileId,
}: CreateContextIfNotExistCommandPayload): Promise<BaseBackResponse> {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        fileId,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default createContextIfNotExistCommand;
